import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH,
  GET_SCHEDULE_RESERVATION_DISPATCH,
  SCHEDULE_DISPATCH,
} from '../../actions';

export type stateScheduleReservation = {
  scheduleDispatch: {
    clubId: number;
    clubName: string;
    imageDate: string;
  };
  scheduleReservation: {
    contentsId: number;
    clubId: number;
    clubName: string;
    infoDate: string;
    contentStartTime: string;
    contentEndTime: string;
    week: string;
    cancelWaitNotice: string;
  };
  scheduleCompleteReservation: {
    registerFlg: number; // 1:予約 2:キャンセル待ち
    clubName: string;
    reservationDateTime: string;
    cancelTime: string;
    companionNum: number;
    companionShowFlg: boolean;
    annexFlag: number;
    contentsName: string;
    eqsName: string;
    spaceName: string;
    clubAddress: string;
  };
};

const initialState: stateScheduleReservation = {
  scheduleDispatch: {
    clubId: 0,
    clubName: '',
    imageDate: '',
  },
  scheduleReservation: {
    contentsId: 0,
    clubId: 0,
    clubName: '',
    infoDate: '',
    contentStartTime: '',
    contentEndTime: '',
    week: '',
    cancelWaitNotice: '0',
  },
  scheduleCompleteReservation: {
    registerFlg: 1,
    clubName: '',
    reservationDateTime: '',
    cancelTime: '',
    companionNum: 0,
    companionShowFlg: false,
    annexFlag: 0,
    contentsName: '',
    eqsName: '',
    spaceName: '',
    clubAddress: '',
  },
};

const ScheduleReservationStateReducer = (prevState = initialState, action: AnyAction): stateScheduleReservation => {
  return produce(prevState, (draft) => {
    const state = draft;
    switch (action.type) {
      case SCHEDULE_DISPATCH:
        if (action.clubId !== undefined) {
          state.scheduleDispatch.clubId = action.clubId;
        }
        if (action.clubName !== undefined) {
          state.scheduleDispatch.clubName = action.clubName;
        }
        if (action.imageDate !== undefined) {
          state.scheduleDispatch.imageDate = action.imageDate;
        }
        break;
      case GET_SCHEDULE_RESERVATION_DISPATCH:
        state.scheduleReservation.contentsId = action.contentsId;
        state.scheduleReservation.clubId = action.clubId;
        state.scheduleReservation.clubName = action.clubName;
        state.scheduleReservation.infoDate = action.infoDate;
        state.scheduleReservation.contentStartTime = action.contentStartTime;
        state.scheduleReservation.contentEndTime = action.contentEndTime;
        state.scheduleReservation.week = action.week;
        state.scheduleReservation.cancelWaitNotice = action.cancelWaitNotice;
        break;
      case GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH:
        state.scheduleCompleteReservation.registerFlg = action.registerFlg;
        state.scheduleCompleteReservation.clubName = action.clubName;
        state.scheduleCompleteReservation.reservationDateTime = action.reservationDateTime;
        state.scheduleCompleteReservation.cancelTime = action.cancelTime;
        state.scheduleCompleteReservation.companionNum = action.companionNum;
        state.scheduleCompleteReservation.companionShowFlg = action.companionShowFlg;
        state.scheduleCompleteReservation.annexFlag = action.annexFlag;
        state.scheduleCompleteReservation.contentsName = action.contentsName;
        state.scheduleCompleteReservation.eqsName = action.eqsName;
        state.scheduleCompleteReservation.spaceName = action.spaceName;
        state.scheduleCompleteReservation.clubAddress = action.clubAddress;
        break;
      default:
        break;
    }
  });
};

export default ScheduleReservationStateReducer;
